const { Criteria } = Shopware.Data;
const { Mixin } = Shopware;

const AXES = [
    { key: 'fruchtig', label: 'fruchtig' },
    { key: 'suess', label: 'süß' },
    { key: 'frisch', label: 'frisch & kühl' },
    { key: 'saeuerlich', label: 'säuerlich' },
    { key: 'cremig', label: 'cremig' },
];

export default {
    template: `
<sw-page class="riccardo-advisor-detail">
    <template #smart-bar-header><h2>{{ question ? (question.title || 'Neue Frage') : '' }}</h2></template>
    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.advisor.list' }">Abbrechen</sw-button>
        <sw-button-process variant="primary" :is-loading="isLoading" :process-success="isSaveSuccessful" @click="onSave">Speichern</sw-button-process>
    </template>
    <template #content>
        <sw-card-view v-if="question">
            <sw-card title="Frage" :is-loading="isLoading">
                <sw-container columns="2fr 1fr 1fr" gap="0 24px">
                    <sw-text-field v-model:value="question.title" label="Frage" required />
                    <sw-single-select v-model:value="question.flow" label="Berater" :options="flowOptions" />
                    <sw-number-field v-model:value="question.position" number-type="int" label="Position" />
                </sw-container>
                <sw-text-field v-model:value="question.subtitle" label="Zusatzzeile" placeholder="z. B. Mehrfachauswahl möglich" />
                <sw-text-field v-model:value="question.code" label="Kürzel" help-text="Technischer Name, erscheint in der Adresse der Ergebnisseite" required />
                <sw-container columns="repeat(3, 1fr)" gap="0 24px">
                    <sw-switch-field v-model:value="question.active" label="Aktiv" />
                    <sw-switch-field v-model:value="question.multiple" label="Mehrfachauswahl" />
                    <sw-switch-field v-model:value="question.required" label="Pflichtfrage" />
                </sw-container>
            </sw-card>

            <sw-card title="Antworten" :is-loading="isLoading">
                <div v-for="(option, index) in options" :key="option.id" style="border-top: 1px solid #e0e6eb; padding: 16px 0;">
                    <sw-container columns="2fr 2fr 1fr 1fr auto" gap="0 16px" align="end">
                        <sw-text-field v-model:value="option.label" label="Antwort" />
                        <sw-text-field v-model:value="option.description" label="Erklärung" />
                        <sw-text-field v-model:value="option.color" label="Farbe" placeholder="#FFD66B" />
                        <sw-number-field v-model:value="option.position" number-type="int" label="Position" />
                        <sw-button variant="danger" style="margin-bottom: 22px" @click="removeOption(index)">Entfernen</sw-button>
                    </sw-container>

                    <template v-if="question.flow === 'device'">
                        <sw-container columns="2fr 1fr 1fr 1fr 1fr" gap="0 16px">
                            <sw-multi-tag-select :value="weightList(option, 'builds')" label="Bauarten (Reihenfolge = Empfehlung)" placeholder="Pod-System, Komplett-Set, Akkuträger, Verdampfer" @update:value="v => setWeight(option, 'builds', v)" />
                            <sw-number-field :value="weight(option, 'batteryMin')" number-type="int" label="Akku ab (mAh)" @update:value="v => setWeight(option, 'batteryMin', v)" />
                            <sw-number-field :value="weight(option, 'wattMin')" number-type="int" label="Watt ab" @update:value="v => setWeight(option, 'wattMin', v)" />
                            <sw-number-field :value="weight(option, 'wattMax')" number-type="int" label="Watt bis" @update:value="v => setWeight(option, 'wattMax', v)" />
                            <sw-number-field :value="weight(option, 'priceMax')" number-type="float" label="Preis bis (€)" @update:value="v => setWeight(option, 'priceMax', v)" />
                        </sw-container>
                        <sw-container columns="1fr 1fr 3fr" gap="0 16px">
                            <sw-number-field :value="weight(option, 'priceMin')" number-type="float" label="Preis ab (€)" @update:value="v => setWeight(option, 'priceMin', v)" />
                            <sw-number-field :value="weight(option, 'tankMin')" number-type="float" label="Tank ab (ml)" @update:value="v => setWeight(option, 'tankMin', v)" />
                            <sw-switch-field :value="!!weight(option, 'filterBuilds')" label="Bauarten strikt (andere ausschließen)" @update:value="v => setWeight(option, 'filterBuilds', v)" />
                        </sw-container>
                    </template>

                    <template v-else>
                        <sw-container columns="1fr 1fr" gap="0 16px">
                            <sw-multi-tag-select :value="weightList(option, 'groups')" label="Geschmacksgruppen" placeholder="Frucht, Süß & Dessert, Frisch & Kühl, Getränk, Tabak" @update:value="v => setWeight(option, 'groups', v)" />
                            <sw-multi-tag-select :value="weightList(option, 'notes')" label="Noten" placeholder="Mango, Erdbeere …" @update:value="v => setWeight(option, 'notes', v)" />
                        </sw-container>
                        <sw-container columns="1fr 1fr" gap="0 16px">
                            <sw-multi-tag-select :value="weightList(option, 'liquidTypes')" label="Liquid-Typen" placeholder="Nikotinsalz, Longfill, Basis / Shot" @update:value="v => setWeight(option, 'liquidTypes', v)" />
                            <sw-multi-tag-select :value="weightList(option, 'avoid')" label="Ausschließen, wenn enthalten" placeholder="Kühle, Tabak …" @update:value="v => setWeight(option, 'avoid', v)" />
                        </sw-container>
                        <div style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 16px;">
                            <sw-number-field v-for="axis in axes" :key="axis.key" :value="axisValue(option, axis.key)" number-type="int" :label="'Ziel ' + axis.label + ' (0–5)'" @update:value="v => setAxis(option, axis.key, v)" />
                        </div>
                        <sw-container columns="1fr 1fr 2fr" gap="0 16px">
                            <sw-switch-field :value="!!weight(option, 'filterGroups')" label="Gruppen strikt" @update:value="v => setWeight(option, 'filterGroups', v)" />
                            <sw-switch-field :value="!!weight(option, 'filterTypes')" label="Liquid-Typen strikt" @update:value="v => setWeight(option, 'filterTypes', v)" />
                        </sw-container>
                    </template>
                </div>
                <sw-button @click="addOption">Antwort hinzufügen</sw-button>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    mixins: [Mixin.getByName('notification')],

    props: {
        questionId: { type: String, required: false, default: null },
        flow: { type: String, required: false, default: 'flavor' },
    },

    data() {
        return { question: null, isLoading: false, isSaveSuccessful: false, axes: AXES };
    },

    computed: {
        questionRepository() {
            return this.repositoryFactory.create('riccardo_advisor_question');
        },
        optionRepository() {
            return this.repositoryFactory.create('riccardo_advisor_option');
        },
        flowOptions() {
            return [
                { value: 'flavor', label: 'Aromenberater' },
                { value: 'device', label: 'Geräteberater' },
            ];
        },
        options() {
            if (!this.question?.options) {
                return [];
            }
            return [...this.question.options].sort((a, b) => (a.position || 0) - (b.position || 0));
        },
    },

    created() {
        this.load();
    },

    methods: {
        load() {
            if (!this.questionId) {
                this.question = this.questionRepository.create();
                this.question.flow = this.flow;
                this.question.active = true;
                this.question.position = 100;
                this.question.multiple = false;
                this.question.required = true;
                this.question.code = '';
                return Promise.resolve();
            }
            this.isLoading = true;
            const criteria = new Criteria();
            criteria.addAssociation('options');
            return this.questionRepository.get(this.questionId, Shopware.Context.api, criteria).then((question) => {
                this.question = question;
            }).finally(() => { this.isLoading = false; });
        },

        weight(option, key) {
            return option.weights?.[key] ?? null;
        },
        weightList(option, key) {
            return option.weights?.[key] ?? [];
        },
        axisValue(option, axis) {
            return option.weights?.axes?.[axis] ?? null;
        },
        setWeight(option, key, value) {
            const weights = { ...(option.weights || {}) };
            if (value === null || value === '' || value === false || (Array.isArray(value) && !value.length)) {
                delete weights[key];
            } else {
                weights[key] = value;
            }
            option.weights = weights;
        },
        setAxis(option, axis, value) {
            const weights = { ...(option.weights || {}) };
            const axes = { ...(weights.axes || {}) };
            if (value === null || value === '') {
                delete axes[axis];
            } else {
                axes[axis] = Number(value);
            }
            weights.axes = axes;
            if (!Object.keys(axes).length) {
                delete weights.axes;
            }
            option.weights = weights;
        },

        addOption() {
            const option = this.optionRepository.create();
            option.label = '';
            option.code = `option-${Date.now().toString(36)}`;
            option.position = (this.options.length + 1) * 10;
            option.weights = {};
            this.question.options.add(option);
        },

        removeOption(index) {
            const option = this.options[index];
            this.question.options.remove(option.id);
        },

        onSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;
            if (!this.question.code) {
                this.question.code = (this.question.title || 'frage').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
            }
            this.question.options.forEach((option) => {
                if (!option.code) {
                    option.code = (option.label || 'antwort').toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40);
                }
            });
            return this.questionRepository.save(this.question).then(() => {
                this.isSaveSuccessful = true;
                this.createNotificationSuccess({ message: 'Frage gespeichert' });
                if (!this.questionId) {
                    this.$router.push({ name: 'riccardo.advisor.detail', params: { id: this.question.id } });
                    return Promise.resolve();
                }
                return this.load();
            }).catch(() => {
                this.createNotificationError({ message: 'Speichern fehlgeschlagen – Kürzel müssen je Berater eindeutig sein.' });
            }).finally(() => { this.isLoading = false; });
        },
    },
};
